export const validatePassword = (rule, value, callback) => {
    if (value && !value.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!.,:;*?_()@#$%^&+=])/)) {
        callback('Hasło powinno zawierać przynajmniej jedną małą, jedną wielką literę, jedną cyfrę i jeden znak specjalny.');
    } else {
        callback();
    }
}
